import { useFeatureIsOn as gbUseFeatureIsOn } from '@growthbook/growthbook-react';
import type { FeatureMap } from './helpers';

export const useFeatureIsOn = (flag: keyof PickKeysOfType<FeatureMap, boolean>) => {
  const enabled = gbUseFeatureIsOn(flag);

  return { enabled };
};
